import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";

const ViewVendorBids = () => {
  const [bids, setBids] = useState();
  const { tenderId } = useParams();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getBids = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/get-by-vendor?vendorId=${vendorId}&tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBids(res.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error updating vendor status:", error);
      }
    };
    getBids();
  }, []);

  const groupedWorkItems =
    bids &&
    bids[0].bidWorkItems.reduce((acc, item) => {
      if (!acc[item.section]) acc[item.section] = [];
      acc[item.section].push(item);
      return acc;
    }, {});

    useEffect(() => {
    const leftRows = document.querySelectorAll("#leftTable tbody tr");
    const rightRows = document.querySelectorAll("#rightTable tbody tr");

    for (let i = 0; i < Math.min(leftRows.length, rightRows.length); i++) {
      const leftHeight = leftRows[i].getBoundingClientRect().height;
      const rightHeight = rightRows[i].getBoundingClientRect().height;

      const maxHeight = Math.max(leftHeight, rightHeight);

      leftRows[i].style.height = `${maxHeight}px`;
      rightRows[i].style.height = `${maxHeight}px`;
    }
  }, [groupedWorkItems]);

  return (
    <div>
      <Typography variant="h4">Bids Information</Typography>
      <Box className="dashboard-container" p={5}>
        <Typography className="form-title">Technical Details</Typography>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : bids && bids.filter((bid) => bid.ts1).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "20px", width: "240px" }}>
                    Technical Specification
                  </th>
                </tr>
              </thead>
              <tbody>
                {bids
                  .filter((bid) => bid.ts1)
                  .map((bid, i) => (
                    <tr key={i}>
                      <td
                        style={{
                          borderTop: "1px solid #ccc",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        {bid[`ts${i + 1}`] ? `TS-${i + 1}` : null}
                      </td>
                    </tr>
                  ))}
                <tr>
                  <td
                    colSpan={1}
                    style={{
                      borderTop: "1px solid #ccc",
                    }}
                  >
                    Current Status
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bids && bids?.length * 200}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ padding: "20px", width: "340px" }}>
                      Uploaded Document
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bids
                    .filter((bid) => bid.ts1)
                    .map((bid, i) => (
                      <tr key={i}>
                        {bids
                          .filter((bid) => bid.ts1)
                          .map((bid, j) => {
                            const docUrl = bid && bid[`ts${i + 1}`];
                            return (
                              <td
                                key={j}
                                style={{
                                  borderTop: "1px solid #ccc",
                                  borderRight: "1px solid #ccc",
                                  height: "40px",
                                }}
                              >
                                {docUrl ? (
                                  <Button
                                    sx={{
                                      margin: "0 !important",
                                      padding: "0 !important",
                                      width: "auto !important",
                                      fontSize: "14px !important",
                                      textDecoration: "underline",
                                      textAlign: "start",
                                    }}
                                    onClick={() => viewPDF(docUrl, storedUser)}
                                  >
                                    {bid[`ts${i + 1}Filename`]}
                                  </Button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                  <tr>
                    {bids
                      .filter((bid) => bid.ts1)
                      .map((bid, index) => (
                        <td
                          key={index}
                          style={{
                            borderTop: "1px solid #ccc",
                            height: "40px",
                          }}
                        >
                          {bid.bidStatus !== "SUBMITTED"
                            ? "APPROVED"
                            : bid.bidStatus === "REJECTED"
                            ? "REJECTED"
                            : "IN REVIEW"}
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor bid for the tender
          </Typography>
        )}
      </Box>
      <Box className="dashboard-container" p={5}>
        <Typography className="form-title">Bids Details</Typography>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : bids && bids.filter(Boolean).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
            id="leftTable"
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      padding: "9px",
                      width: "150px",
                      height: "59px",
                    }}
                  >
                    Item Name
                  </th>
                  <th style={{ padding: "9px", width: "240px" }}>
                    Item Description
                  </th>
                  <th style={{ padding: "9px", width: "100px" }}>UOM</th>
                  <th style={{ padding: "9px", width: "100px" }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                      <tr
                        style={{
                          borderTop: "1px solid #ccc",
                          fontWeight: "bold",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "left",
                            padding: "0px 10px",
                            height: "40px",
                          }}
                        >
                          Section: {section}
                        </td>
                      </tr>
                      {items
                        .sort((a, b) => a.itemOrder - b.itemOrder)
                        .map((item, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                                // height: "50px",
                                padding: '10px'
                              }}
                            >
                              {item.itemName}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.description}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.unit}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.quantity}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      borderTop: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Grand Total
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={4}
                    style={{ borderTop: "1px solid #ccc", height: "40px" }}
                  >
                    Current Status
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
              id="rightTable"
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bids && bids?.length * 250}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {bids.map((_, i) => (
                      <React.Fragment key={i}>
                        <th
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                          colSpan={2}
                        >
                          Bid {i + 1}
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                  <tr>
                    {bids.map((_, i) => (
                      <React.Fragment key={i}>
                        <th
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Rate
                        </th>
                        <th
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Total
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        {/* Section Totals */}
                        <tr
                          style={{
                            borderTop: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          {bids.map((bid, i) => {
                            const sectionItems = bid.bidWorkItems.filter((bi) =>
                              items.find((wi) => wi.itemName === bi.itemName)
                            );
                            const sectionTotal = sectionItems.reduce(
                              (sum, si) => sum + ((si.quantity * si.rate) || 0),
                              0
                            );
                            return (
                              <React.Fragment key={i}>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "end",
                                    padding: "10px",
                                    height: "40px",
                                    borderRight: "1px solid #ccc",
                                  }}
                                >
                                  {sectionTotal}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                        {items.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {bids.map((bid, i) => {
                              const matchedItem = bid.bidWorkItems.find(
                                (bi) => bi.itemName === item.itemName
                              );
                              return (
                                <React.Fragment key={i}>
                                  <td
                                    style={{
                                      borderTop: "1px solid #ccc",
                                      borderRight: "1px solid #ccc",
                                      // height: "50px",
                                      padding: '10px'
                                    }}
                                  >
                                    {matchedItem?.rate || ""}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid #ccc",
                                      borderRight: "1px solid #ccc",
                                    }}
                                  >
                                    {(matchedItem?.quantity * matchedItem?.rate) || ""}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        ))}
                      </React.Fragment>
                    )
                  )}

                  {/* Grand Totals */}
                  <tr
                    style={{ fontWeight: "bold", borderTop: "1px solid #ccc" }}
                  >
                    {bids.map((bid, i) => {
                      const grandTotal = bid.bidWorkItems.reduce(
                        (acc, item) => acc + ((item.quantity * item.rate) || 0),
                        0
                      );
                      return (
                        <td
                          key={i}
                          colSpan={2}
                          style={{
                            textAlign: "end",
                            padding: "10px",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          {grandTotal}
                        </td>
                      );
                    })}
                  </tr>

                  {/* Current Status Row - unchanged */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td
                        key={i}
                        colSpan={2}
                        style={{
                          borderTop: "1px solid #ccc",
                          height: "40px",
                        }}
                      >
                        {bid.bidStatus}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No bids for the tender
          </Typography>
        )}
      </Box>
      <Box className="btn-container">
        <Button
          className="btn-outlined"
          onClick={() => navigate(`/vendor/dashboard/${tenderId}`)}
        >
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewVendorBids;
